var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle, withBgClickEvent: true },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ invalid, dirty }) {
                    return [
                      _c(
                        "ModalContent",
                        [
                          _vm.hideContractorsMessage
                            ? _c("WindowAlerts", {
                                staticClass: "mb-4 -mt-1",
                                attrs: { items: _vm.alerts },
                              })
                            : _vm._e(),
                          _c("ValidationProvider", {
                            attrs: {
                              rules: "required_field",
                              name: "Group Name",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("FormGroup", {
                                        staticClass: "mb-4",
                                        attrs: {
                                          errors: errors,
                                          inputClass: "fullwidthInput",
                                          isIcon: false,
                                          name: "project_title",
                                          placeholder: "Enter name",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-icon",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("Group Name "),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.group.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.group, "name", $$v)
                                          },
                                          expression: "group.name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("ValidationProvider", {
                            attrs: {
                              name: "contractors",
                              rules: _vm.contractorRules,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors, failed }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          staticClass: "mb-4",
                                          attrs: {
                                            errors: errors,
                                            name: "contractor",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "p",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm.contractorRules
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "required-icon",
                                                              },
                                                              [_vm._v("*")]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.contractorsTitle
                                                          ) + " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("ContractorsMultiselect", {
                                            attrs: {
                                              value: _vm.selectedContractorsIds,
                                              invalid: failed,
                                              max: 5,
                                              contractorsConditions:
                                                _vm.contractorsWhere,
                                              placeholder: "Select contractors",
                                              getParentcontainerStyle:
                                                "customWidthInput",
                                              title: "Contractors",
                                            },
                                            on: {
                                              input: _vm.handleContractorInput,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm.showManagersFilter
                            ? _c(
                                "FormGroup",
                                {
                                  staticClass: "mb-4",
                                  attrs: { name: "managers" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [
                                            _c("p", { staticClass: "mb-2" }, [
                                              _vm._v("Managers"),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("ManagersMultiselect", {
                                    attrs: {
                                      value: _vm.managersIds,
                                      max: 5,
                                      placeholder: "Select managers",
                                      getParentcontainerStyle:
                                        "customWidthInput",
                                      title: "Managers",
                                    },
                                    on: { input: _vm.handleManagerInput },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "mb-4",
                              attrs: { name: "skills" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("p", { staticClass: "mb-2" }, [
                                          _vm._v("Skills"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("CustomSkillsMultiselect", {
                                attrs: {
                                  max: 10,
                                  previouslyChosenSkillsIds: _vm.group.skills,
                                  getParentContainer: "customWidthInput",
                                  customSkillLabel: "Add personal skill",
                                },
                                on: { skillsListUpdated: _vm.updateSkills },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "mb-4",
                              attrs: { name: "projects" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("p", { staticClass: "mb-2" }, [
                                          _vm._v("Clients"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("ProjectsMultiselect", {
                                attrs: {
                                  value: _vm.chosenProjectsIds,
                                  title: "Clients",
                                  getcontainerStyle:
                                    "customWidthInput customHeightInput",
                                  projectsConditions: _vm.projectsWhere,
                                },
                                on: { input: _vm.handleProjectInput },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                name: "postings",
                                inputClass: "fullwidthInput",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("p", { staticClass: "mb-2" }, [
                                          _vm._v("Postings"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("PostingsMultiselect", {
                                attrs: {
                                  value: _vm.postingValue,
                                  title: "Postings",
                                  getcontainerStyle: "customWidthInput",
                                  postingsConditions: _vm.postingsWhere,
                                },
                                on: { input: _vm.handlePostingInput },
                              }),
                            ],
                            1
                          ),
                          _c("FormGroup", {
                            staticClass: "mb-4",
                            attrs: {
                              name: "group_location",
                              inputClass: "fullwidthInput",
                              isIcon: false,
                              placeholder: "Enter location",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("p", { staticClass: "mb-2" }, [
                                        _vm._v("Location"),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.group.location,
                              callback: function ($$v) {
                                _vm.$set(_vm.group, "location", $$v)
                              },
                              expression: "group.location",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "flex pt-5 justify-end" },
                            [
                              _c("UiButton", {
                                staticClass: "mr-3",
                                attrs: {
                                  id: "cancelGroup",
                                  variant: "outline",
                                  buttonClasses: "customButtonCard",
                                  buttonText: "Cancel",
                                  size: "lg",
                                },
                                on: { click: _vm.closeModal },
                              }),
                              _vm.data
                                ? _c("UiButton", {
                                    attrs: {
                                      type: "submit",
                                      variant: "black",
                                      buttonClasses: "customButtonCard",
                                      id: "updateGroup",
                                      size: "lg",
                                      disabled: invalid,
                                      buttonText: "Update",
                                    },
                                    on: { click: _vm.handleSubmit },
                                  })
                                : _c("UiButton", {
                                    attrs: {
                                      type: "submit",
                                      size: "lg",
                                      variant: "black",
                                      id: "createGroupM",
                                      buttonClasses: "customButtonCard",
                                      disabled: invalid || !dirty,
                                      buttonText: "Create",
                                    },
                                    on: { click: _vm.handleSubmit },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }